import isBrowser from "./isBrowser";

export default function getViewportDimensions() {
  if (isBrowser()) {
    return {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
    };
  }

  return {
    width: 0,
    height: 0,
  };
}
